import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Rectangle,
} from "recharts";

const data = [
  { name: "A", uv: 4000 },
  { name: "B", uv: 3000 },
  { name: "C", uv: 2000 },
  { name: "D", uv: 2780 },
  { name: "E", uv: 1890 },
  { name: "F", uv: 2390 },
  { name: "G", uv: 3490 },
];

const DistributionChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          barSize={20}
          dataKey="uv"
          fill="#EE3E38"
          activeBar={<Rectangle fill="#EE3E38" stroke="#EE3E38" />}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DistributionChart;
